// Constants.js

const prod = {
  urls: {
    ACCOUNT_URL: 'https://account-be.intego.com',
  },
}

const dev = {
  urls: {
    ACCOUNT_URL: 'https://account-be-staging.intego.com',
  },
}

// export const config = prod
export const config = process.env.NODE_ENV === 'production' ? prod : dev

export const LINKS = {
  newAccountUrl : {
    stage: "https://account-staging-v2.intego.com",
    prod: "https://account-v2.intego.com"
  }
}

const MIXPANEL_TOKENS = {
  staging: 'd9defcf248353d456aae6c5adb1af106',
  production: '783be65582377e8b0f3061557741a54b',
}

export const MIXPANEL_TOKEN =
  process.env.REACT_APP_MIXPANEL_TOKEN ||
  (process.env.NODE_ENV !== 'production' ||
  (typeof window !== 'undefined' && window.location.hostname.includes('staging'))
    ? MIXPANEL_TOKENS.staging
    : MIXPANEL_TOKENS.production)
